import { useEffect, useState } from 'react'

/**
 * Returns `value` after it has stayed unchanged for `delayMs`.
 * Useful for debouncing text input without coupling timers to unrelated effect dependencies.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
